import { initialUserState, IUserState } from 'session/state/user/userState';

export interface IGlobalState extends IUserState {}

export const globalState: IGlobalState = {
    ...initialUserState
};
